export default __webpack_public_path__ + "static/medialinq-feature-phone-0e0848599a4350df637ad4c4a63650aa.png";